import {translate} from 'shared/services/I18nService';

const SETTINGS_BUTTON_TOOLTIP = 'uScope.extensions.snapshot.settings-icon-alt-text';

export const createToolUiButton = (mainUi) => {
  const settingsButton = document.createElement('button');
  // Note: IE doesn't support classlist.Add() with multiple classes
  settingsButton.className += 'snapshot-settings-button uscope-toolbar-button';
  settingsButton.title = translate(SETTINGS_BUTTON_TOOLTIP);
  settingsButton.addEventListener('click', (e) => {
    // Open the UI, vs showing it, to ensure it becomes visible.
    mainUi.open(settingsButton);
    e.preventDefault();
    e.stopImmediatePropagation();
    return false;
  });
  return settingsButton;
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/toolbar-button/show-ui-button.js